export default class DataGridRowObject {
    public RowData: any;
    public IsExpanded: boolean = false;
    public IsSelected: boolean = false;
    public ToggleDetails: any;
}
